import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../auth/components/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class UserResolver implements Resolve<unknown> {
    constructor(private authService: AuthService) {}
    resolve(): Observable<unknown> {
        return this.authService.getCurrentUser().pipe(
            catchError(() => {
                return of('No data');
            }),
        );
    }
}
